export enum IYesNoEnum {
    Y = "Y",
    N = "N",
}
export enum EAddressType {
    B = "B",
    S = "S",
}
